import { Button } from '@synoptic/ui-kit/button/button.tsx';
import { useToast } from '@synoptic/ui-kit/toast/toast-provider.tsx';
import { useCallbackRef } from '@synoptic/ui-kit/utils/use-callback-ref.tsx';
import { FC, useEffect } from 'react';
import { useSetUsername } from '@/components/set-username/use-set-username';
import { useConnectToX } from '@/components/xcom-tag/use-connect-to-x';
import { submitAuthFormButton } from '../../_auth/page.css';

export const ClaimTwitterUsername: FC<{
  onChooseUsername: (username: string) => void;
  xComHandle: string | null | undefined;
}> = ({ onChooseUsername, xComHandle }) => {
  const { authLink, isAfterConnect } = useConnectToX();

  const [setUsername, result] = useSetUsername();
  const toast = useToast();

  const handleSetUsername = useCallbackRef(async () => {
    try {
      await setUsername(xComHandle as string);
      onChooseUsername(xComHandle as string);
    } catch (e) {
      toast.error({ title: String(e) });
    }
  });

  useEffect(() => {
    if (xComHandle && isAfterConnect) {
      handleSetUsername();
    }
  }, [xComHandle, handleSetUsername, isAfterConnect]);

  return !xComHandle ? (
    <Button className={submitAuthFormButton} size={'large'} asChild>
      <a href={authLink}>Login with X (Twitter)</a>
    </Button>
  ) : (
    <Button
      className={submitAuthFormButton}
      size={'large'}
      disabled={result.loading}
      loading={result.loading}
      onClick={handleSetUsername}
      style={{ width: '100%' }}
    >
      Continue as {xComHandle}
    </Button>
  );
};
